import { cn } from '@/shared/utils/cn'
import { statusLabel, statusTone } from './referenceUtils'

interface Props {
  status: string | null | undefined
  className?: string
}

/**
 * Status pill for Reference Library cards — shares look/tone with the
 * Documents Library badge so the two surfaces feel like one product.
 */
export function ReferenceStatusBadge({ status, className }: Props) {
  const tone = statusTone(status)
  return (
    <span className={cn('doc-status-badge', `tone-${tone}`, className)}>
      <span className="doc-status-dot" aria-hidden="true" />
      {statusLabel(status)}
    </span>
  )
}
